import React, { useState } from 'react';
import './RecipeStory.css';

function RecipeStory() {
  const [expanded, setExpanded] = useState(false);

  const toggleStory = () => {
    setExpanded(!expanded);
  };

  return (
    <section className="recipe-story">
      <div className="story-header" onClick={toggleStory}>
        <h2>The Story Behind This Recipe</h2>
        <button className="toggle-button">
          {expanded ? 'Collapse ▲' : 'Read Story ▼'}
        </button>
      </div>
      
      <div className={`story-container ${expanded ? 'expanded' : 'collapsed'}`}>
        <p>
          When I moved from Maharashtra, India to the United States, I found myself longing for the authentic taste of Mumbai's ladi pav—those perfectly soft, slightly sweet dinner rolls that are a staple of Maharashtrian cuisine. Despite visiting countless bakeries and grocery stores, I couldn't find anything that matched the distinct texture and flavor I remembered from home.
        </p>
        <p>
          Determined to recreate this taste of home, I embarked on a culinary journey that spanned years. I studied multiple recipes, consulted with bakers, and made countless batches—tweaking ingredients and techniques with each iteration. I faced unique challenges adapting the recipe to American ingredients: finding the right protein content in flour, adjusting for differences in dairy products, and accounting for variations in yeast behavior.
        </p>
        <p>
          After years of patient experimentation, this recipe emerged—a version of Mumbai ladi pav that finally captures the essence of what I remember from Maharashtra, India, but made entirely with ingredients available in American stores. The result is these golden-brown, pillowy soft rolls with that signature slight sweetness and perfect texture that makes them ideal for beloved street food dishes like vada pav (potato fritters in bread), pav bhaji (vegetable curry with bread), misal pav (spicy sprouts curry with bread), or simply enjoyed with butter and chai.
        </p>
        <p>
          Each time I bake these pav, they bring a piece of Mumbai into my American kitchen. These versatile dinner rolls are the foundation for so many iconic dishes from Maharashtra, India, and now you can recreate this essential bread at home. I hope they'll bring the same joy to your kitchen.
        </p>
      </div>
    </section>
  );
}

export default RecipeStory;